import React, { useContext } from 'react';
import { Table, TableBody, TableCell, TableRow, TableContainer } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LocalizationContext from '../../../../contexts/LocalizationContext';
import { AccountContext } from '../context/AccountProvider';
import PortraitIcon from '@material-ui/icons/Portrait';
import inSection from '../../../hoc/inSection';

const useStyles = makeStyles({
    key: {
        fontWeight: 600,
        paddingLeft: 0,
        paddingRight: 0,
    },
    value: {
        paddingLeft: 0,
        paddingRight: 0,
    },
    row: {
        fontSize: '16px',
        fontFamily: '"Open Sans", "Roboto", "Helvetica", "Arial", sans-serif',
    },
});

const PersonalInfo = () => {
    const classes = useStyles();
    const localization = useContext(LocalizationContext);
    const account = useContext(AccountContext);

    return (
        <TableContainer style={{ marginTop: '12px', marginBottom: '-6px' }}>
            <Table>
                <TableBody>
                    <TableRow className={classes.row}>
                        <TableCell className={classes.key}>{localization.strings.employeeDetails.name}</TableCell>
                        <TableCell className={classes.value}>
                            {account.account?.firstName} {account.account?.lastName}
                        </TableCell>
                    </TableRow>
                    <TableRow className={classes.row}>
                        <TableCell className={classes.key}>{localization.strings.account.employeeNumber}</TableCell>
                        <TableCell className={classes.value}>{account.account?.employeeNumber}</TableCell>
                    </TableRow>
                    <TableRow className={classes.row}>
                        <TableCell className={classes.key}>{localization.strings.employeeDetails.email}</TableCell>
                        <TableCell className={classes.value}>{account.account?.email}</TableCell>
                    </TableRow>
                    <TableRow className={classes.row}>
                        <TableCell className={classes.key}>{localization.strings.account.jobTitle}</TableCell>
                        <TableCell className={classes.value}>{account.account?.jobTitle}</TableCell>
                    </TableRow>
                    <TableRow className={classes.row}>
                        <TableCell className={classes.key}>{localization.strings.account.department}</TableCell>
                        <TableCell className={classes.value}>{account.account?.department}</TableCell>
                    </TableRow>
                    <TableRow className={classes.row}>
                        <TableCell className={classes.key}>{localization.strings.account.officeLocation}</TableCell>
                        <TableCell className={classes.value}>{account.account?.officeLocation}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default inSection(PersonalInfo, { icon: PortraitIcon, sectionTitleString: 'personalInfo' }, true);
